import { lazy } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../../Components/Admin/ProtectedRoute';

// Ленивая подгрузка страниц — код модуля не попадает в стартовый бандл.
const WarehouseLayout = lazy(() => import('./WarehouseLayout'));
const WarehouseDashboard = lazy(() => import('./pages/WarehouseDashboard'));
const OrderHelp = lazy(() => import('./pages/OrderHelp'));
const OrderList = lazy(() => import('./pages/OrderList'));
const OrderForm = lazy(() => import('./pages/OrderForm'));
const OrderDetail = lazy(() => import('./pages/OrderDetail'));
const WarehouseSettings = lazy(() => import('./pages/WarehouseSettings'));
const WarehouseStatusSettings = lazy(() => import('./pages/WarehouseStatusSettings'));
const StatusTransitionSettings = lazy(() => import('./pages/StatusTransitionSettings'));
const WarehousePickingSettings = lazy(() => import('./pages/WarehousePickingSettings'));
const CounterpartyList = lazy(() => import('../admin/pages/counterparties/CounterpartyList'));
const CounterpartyEdit = lazy(() => import('../admin/pages/counterparties/CounterpartyEdit'));
const ContactPersonList = lazy(() => import('../admin/pages/contactPersons/ContactPersonList'));

const WarehouseRouters = (
  <Route
    path="/warehouse"
    element={
      <ProtectedRoute minRole="USER" appSlug="warehouse">
        <WarehouseLayout />
      </ProtectedRoute>
    }
  >
    <Route index element={<OrderList />} />
    <Route path="dashboard" element={<WarehouseDashboard />} />
    <Route path="help" element={<OrderHelp />} />
    <Route path="new" element={<OrderForm />} />
    <Route path="counterparties" element={<CounterpartyList />} />
    <Route path="counterparties/:id" element={<CounterpartyEdit />} />
    <Route path="contact-persons" element={<ContactPersonList />} />
    <Route path="settings/permissions" element={<WarehouseSettings />} />
    <Route path="settings/statuses" element={<WarehouseStatusSettings />} />
    <Route path="settings/status-transitions" element={<StatusTransitionSettings />} />
    <Route path="settings/picking" element={<WarehousePickingSettings />} />
    <Route path=":id" element={<OrderDetail />} />
    <Route path=":id/edit" element={<OrderForm />} />
  </Route>
);

export default WarehouseRouters;
